import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";

export default function CreateStockForm({
  open,
  onClose,
  onSubmit,
  onReset,
  availableProducts,
  selectedProduct,
  setSelectedProduct,
  quantity,
  setQuantity,
  minStock,
  setMinStock,
  message,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Agregar Stock</DialogTitle>
      <DialogContent>
        {availableProducts.length === 0 ? (
          <Typography color="textSecondary">
            Sin productos para agregar a Stock.
          </Typography>
        ) : (
          <>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Seleccione un producto:
            </Typography>
            <List
              sx={{
                maxHeight: 200,
                overflow: "auto",
                border: "1px solid #ccc",
                mb: 2,
              }}
            >
              {availableProducts.map((prod) => (
                <ListItemButton
                  key={prod.id}
                  selected={selectedProduct?.id === prod.id}
                  onClick={() => setSelectedProduct(prod)}
                >
                  <ListItemText
                    primary={`${prod.name} - ${prod.product_type?.type}`}
                  />
                </ListItemButton>
              ))}
            </List>

            {selectedProduct && (
              <>
                <TextField
                  margin="dense"
                  label="Cantidad inicial"
                  type="number"
                  fullWidth
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  sx={{ mb: 2 }}
                />
                <TextField
                  margin="dense"
                  label="Stock mínimo"
                  type="number"
                  fullWidth
                  value={minStock}
                  onChange={(e) => setMinStock(e.target.value)}
                  sx={{ mb: 2 }}
                />
              </>
            )}

            {message && (
              <Typography color="error" sx={{ mt: 1 }}>
                {message}
              </Typography>
            )}

            <DialogActions sx={{ justifyContent: "space-between", mt: 2 }}>
              <Button onClick={onReset} color="secondary">
                Restablecer
              </Button>
              <Box>
                <Button onClick={onClose} color="primary">
                  Cerrar
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  onClick={onSubmit}
                  sx={{ ml: 1 }}
                >
                  Confirmar
                </Button>
              </Box>
            </DialogActions>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
